import { useTimeframeTimes as _useTimeframeTimes } from '@griply/hooks';
import { useSubGoals } from 'features/goals';
import { useTasks } from 'features/tasks';
import { useToday } from 'shared/contexts/today';
import { Goal } from 'shared/types/goal';
import { DefaultMetricOptions } from 'shared/types/metric-template';

export const useTimeframeTimes = (goal?: Goal) => {
  const today = useToday();
  const goalId = goal?.id;

  const subGoals = useSubGoals(goalId, true);
  // only read for completed-tasks metrics, and only completedAt — so fetch completed-only, else skip
  const allTasks = useTasks(
    {
      goals: goalId ? [goalId, ...subGoals.map(({ id }) => id)] : [],
      completedOnly: true,
    },
    !!goalId &&
      (!goal?.metric || goal.metric.id === DefaultMetricOptions.CompletedTasks),
  );

  return _useTimeframeTimes(goal, { allTasks, today });
};
